import "./Footer.css"

export function Footer() {
    return   <footer className="bg-light text-dark pt-5 pb-3 border-top">
      <div className="container">

        {/* Columns Section */}
        <div className="row">

          {/* Top AI Tools */}
          <div className="col-md-2">
            <h6 className="fw-bold">Top AI Tools</h6>
            <ul className="list-unstyled small">
              <li>13 Reasons to Switch...</li>
              <li>7 Powerful Speech to Text...</li>
              <li>10 Best Speech to Text Tools...</li>
              <li>13 Free Tools to Easily...</li>
              <li>5 Surprising Ways Google's...</li>
              <li>7 Best Free Online Audio to Text...</li>
              <li>9 Tips to Transcribe...</li>
              <li>13 Best Speech to Text for Windows</li>
              <li>7 Tips for Choosing the Best...</li>
              <li>11 Reasons Why Dragon...</li>
            </ul>
          </div>

          {/* More Tools */}
          <div className="col-md-2">
            <h6 className="fw-bold">More Tools</h6>
            <ul className="list-unstyled small">
              <li>transcription audio en texte</li>
              <li>online audio transcription</li>
              <li>free audio file transcription</li>
              <li>audio and transcript</li>
              <li>chatgpt voice to text</li>
              <li>speech to text reader</li>
              <li>speech to talk</li>
            </ul>
          </div>

          {/* Recommend */}
          <div className="col-md-2">
            <h6 className="fw-bold">Recommend</h6>
            <ul className="list-unstyled small">
              <li>Adobe Firefly...</li>
              <li>How AI Agents Are Redefining...</li>
              <li>Why Internet-Friend Influencers...</li>
              <li>Build a Profitable AI Affiliate...</li>
              <li>Fiverr vs. ChatGPT...</li>
              <li>Report TikToks & Make Money...</li>
              <li>AI Scheduling Tools 2025</li>
            </ul>
          </div>

          {/* Read More */}
          <div className="col-md-2">
            <h6 className="fw-bold">Read more</h6>
            <ul className="list-unstyled small">
              <li>Verbo AI vs HeyGen...</li>
              <li>Marketing EFL Kindergarten...</li>
              <li>Dreaming Big: Budget Strategies...</li>
              <li>AMD RX 9700 XT Review</li>
              <li>AI Chatbots for Small Business</li>
            </ul>
          </div>

          {/* About & Contact */}
          <div className="col-md-2">
            <h6 className="fw-bold">About</h6>
            <ul className="list-unstyled small">
              <li>Fulfillment Policy</li>
              <li>Privacy Policy</li>
            </ul>
            <h6 className="fw-bold mt-3">Contact Us</h6>
            <p className="small">business@toolify.ai</p>
          </div>
        </div>

        {/* Resource & Languages Section */}
        <div className="row mt-4">
          <div className="col-md-6 small">
            <p className="mb-1">Toolify, The Best AI Websites & AI Tools Directory</p>
            <div className="d-flex flex-wrap gap-2">
              <span>English</span>
              <span>简体中文</span>
              <span>繁體中文</span>
              <span>한국어</span>
              <span>日本語</span>
              <span>Português</span>
              <span>Español</span>
              <span>Deutsch</span>
              <span>Français</span>
              <span>Tiếng Việt</span>
            </div>
          </div>
          <div className="col-md-6 text-md-end text-center small mt-3 mt-md-0">
            <img src="/images/logo.webp" alt="Toolify Logo" className="mb-2" style={{ maxWidth: "120px" }} />
            <p className="mb-0">Copyright ©2025 Toolify. All Rights Reserved.</p>
          </div>
        </div>

      </div>
    </footer>
}